import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const NotificationFilled = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="m19.65 17.03-1.08-1.56c-.15-.21-.23-.46-.23-.72v-4.48c0-3.23-2.42-5.89-5.54-6.29v-.79c0-.44-.36-.8-.8-.8-.44 0-.8.36-.8.8v.79a6.335 6.335 0 0 0-5.54 6.29v4.48c0 .26-.08.51-.23.72l-1.08 1.56c-.47.52-.43 1.32.09 1.79.23.21.53.33.85.33h13.43c.7 0 1.27-.57 1.27-1.27 0-.31-.12-.61-.33-.85h-.01ZM12 21.6c1.15 0 2.18-.81 2.56-2.03H9.43c.38 1.21 1.41 2.02 2.56 2.03H12Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default NotificationFilled
//
